import { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import Footer from "./Footer";
import Header from "./Header";
import seoIco1 from "./assets/img/seoIco-1.png";
import seoIco2 from "./assets/img/seoIco-2.png";
import DedicatedTeamsImg3 from "./assets/img/DedicatedTeamsImg-3.png";
const HIPAACompliance = () => {
  return (
    <>
      <Header></Header>
      <div className="mainContent">
        <div className="topPageBanner">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>HIPAA Compliance & IT Security Solutions</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="innerPageIntroData">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="dataWrap text-center">
                  <h2>Protecting Patient Data with Confidence</h2>
                  <p>
                    The{" "}
                    <strong>
                      Health Insurance Portability and Accountability Act
                      (HIPAA) of 1996
                    </strong>{" "}
                    was enacted to ensure the privacy, security, and integrity
                    of protected health information (PHI). Today, HIPAA remains
                    a cornerstone of data protection in the healthcare sector.
                    Oversight is managed by the{" "}
                    <strong>
                      Department of Health and Human Services (HHS)
                    </strong>
                    , with enforcement handled by the{" "}
                    <strong>Office for Civil Rights (OCR)</strong>, which
                    investigates violations and offers guidance on HIPAA best
                    practices.
                  </p>
                  <p>
                    Compliance isn’t a checkbox—it’s an ongoing commitment.
                    Healthcare organizations must adopt a culture of compliance,
                    integrating data security into every process, partnership,
                    and platform they use.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugItroWrap staffAugValueWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imgWrap">
                  <img src={DedicatedTeamsImg3} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadRt">
                  <h2>What is Protected Health Information (PHI)?</h2>
                  <p>
                    <strong>Protected Health Information (PHI)</strong> includes
                    any data that can be used to identify an individual and
                    relates to their health status, healthcare provision, or
                    payment for healthcare services. This includes:
                  </p>
                  <ul>
                    <li>
                      <strong>1. </strong> Full name, address, phone number
                    </li>
                    <li>
                      <strong>2. </strong> Medical records and diagnosis data
                    </li>
                    <li>
                      <strong>3. </strong> Health insurance and billing details
                    </li>
                    <li>
                      <strong>4. </strong> Social Security Number
                    </li>
                    <li>
                      <strong>5. </strong> Biometric identifiers and photographs
                    </li>
                  </ul>
                  <p>
                    <strong>Electronic PHI (ePHI)</strong>—any PHI that is
                    stored, accessed, or transmitted electronically—is regulated
                    under the <strong>HIPAA Security Rule</strong>, which was
                    introduced to address emerging threats in digital health
                    systems.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="fashionWrap aboutSectionWrap">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-md-5">
                <div className="dataWrap sticyDiv">
                  <h2>Who Needs to Be HIPAA Compliant?</h2>
                  <p>
                    HIPAA compliance applies broadly across the healthcare
                    ecosystem. Two primary groups are required to comply:
                  </p>
                </div>
              </div>
              <div className="col-md-7">
                <div className="masonaryWrap">
                  <ResponsiveMasonry
                    columnsCountBreakPoints={{ 380: 1, 480: 2 }}
                  >
                    <Masonry>
                      <div className="itemWrap">
                        <div className="icoWrap">
                          <img src={seoIco1} className="img-fluid" alt="" />
                        </div>
                        <div className="dataWrap">
                          <h2>Covered Entities</h2>
                          <p>
                            Organizations that directly handle PHI in the course
                            of providing healthcare services:
                          </p>
                          <ul>
                            <li>Hospitals & Clinics</li>
                            <li>Doctors, Dentists, and Therapists</li>
                            <li>Health Plans & Insurance Providers</li>
                            <li>Healthcare Clearinghouses</li>
                          </ul>
                        </div>
                      </div>
                      <div className="itemWrap">
                        <div className="icoWrap">
                          <img src={seoIco2} className="img-fluid" alt="" />
                        </div>
                        <div className="dataWrap">
                          <h2>Business Associates</h2>
                          <p>
                            Third-party vendors and service providers who
                            access, process, or manage PHI on behalf of covered
                            entities:
                          </p>
                          <ul>
                            <li>IT Managed Service Providers (MSPs)</li>
                            <li>Billing & Coding Services</li>
                            <li>Cloud Storage Providers</li>
                            <li>EHR/EMR Platforms</li>
                            <li>Law Firms & Accountants</li>
                            <li>Data Destruction Companies</li>
                            <li>Hosting & Email Services</li>
                            <li>Medical Device Vendors</li>
                          </ul>
                          <p>
                            If your company interacts with PHI in any form,{" "}
                            <strong>HIPAA compliance is not optional</strong>.
                          </p>
                        </div>
                      </div>
                    </Masonry>
                  </ResponsiveMasonry>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugItroWrap staffAugValueWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadLt">
                  <h2>Challenges in Compliance – Where Hummingtec Can Help</h2>
                  <p>
                    As HIPAA regulations evolve—especially under updates like
                    <strong> HITECH</strong> and the{" "}
                    <strong>Omnibus Rule</strong>—many healthcare organizations
                    face uncertainty in meeting the increasing standards for
                    data protection.
                  </p>
                  <p>
                    <strong>
                      At Hummingtec , we provide end-to-end IT security and
                      compliance solutions tailored for the healthcare industry.
                    </strong>
                  </p>
                  <p>We help you answer critical questions:</p>
                  <ul>
                    <li>
                      <strong>1. </strong> What impact do HIPAA, HITECH, and
                      Omnibus regulations have on your operations?
                    </li>
                    <li>
                      <strong>2. </strong> Where are the risks in your current
                      IT infrastructure?
                    </li>
                    <li>
                      <strong>3. </strong> What steps must be taken to meet
                      compliance and avoid penalties?
                    </li>
                    <li>
                      <strong>4. </strong> How do you validate and document your
                      compliance to auditors or partners?
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div className="imgWrap">
                  <img src={DedicatedTeamsImg3} className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugBenefitsWrap aiChatBotBen HippaComp">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="ttlWrap">
                  <h2>Our HIPAA Compliance & IT Security Services</h2>
                  <p>
                    Our specialized services are designed to help you identify
                    vulnerabilities, reduce risk, and demonstrate full
                    compliance:
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <ul>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="M59.506 27.903A27.322 27.322 0 0 0 51.47 9.43C46.267 4.226 39.352 1.361 32 1.361c-14.849 0-26.982 11.819-27.505 26.542a6.474 6.474 0 0 0-3.852 5.911v7.262a6.475 6.475 0 0 0 6.468 6.468 4.19 4.19 0 0 0 4.185-4.185V31.53c0-2.167-1.662-3.934-3.775-4.144C8.301 14.559 18.979 4.361 32 4.361c6.552 0 12.713 2.554 17.35 7.191 4.258 4.258 6.75 9.808 7.125 15.835-2.111.212-3.77 1.978-3.77 4.143v11.828c0 2.185 1.688 3.963 3.826 4.148v2.989a6.111 6.111 0 0 1-6.105 6.104h-4.521a4.497 4.497 0 0 0-4.267-3.038h-4.66c-.669 0-1.311.142-1.899.416a4.547 4.547 0 0 0-2.64 4.122c0 1.214.473 2.354 1.33 3.207a4.504 4.504 0 0 0 3.209 1.332h4.66c1.932 0 3.635-1.249 4.27-3.039h4.518c5.021 0 9.105-4.084 9.105-9.104v-3.523a6.473 6.473 0 0 0 3.826-5.898v-7.262c0-2.634-1.586-4.902-3.851-5.909zM8.295 31.53v11.828c0 .653-.531 1.185-1.185 1.185a3.472 3.472 0 0 1-3.468-3.468v-7.262a3.472 3.472 0 0 1 3.468-3.468c.654 0 1.185.532 1.185 1.185zm34.848 26.891a1.546 1.546 0 0 1-1.506 1.219h-4.66c-.41 0-.795-.16-1.089-.454a1.523 1.523 0 0 1-.45-1.085 1.542 1.542 0 0 1 1.539-1.538h4.66c.41 0 .795.159 1.088.453.29.289.45.675.45 1.085.001.11-.011.22-.032.32zm17.214-17.346a3.472 3.472 0 0 1-3.468 3.468 1.186 1.186 0 0 1-1.185-1.185V31.53c0-.653.531-1.185 1.185-1.185a3.472 3.472 0 0 1 3.468 3.468z"
                              fill="#9ceebd"
                              opacity="1"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M41.713 41.592a6.363 6.363 0 0 0 6.356-6.356V22.285c0-1.694-.662-3.29-1.864-4.492s-2.797-1.864-4.492-1.864H22.287a6.363 6.363 0 0 0-6.356 6.356v12.951a6.363 6.363 0 0 0 6.356 6.356h.119v3.356a3.109 3.109 0 0 0 3.112 3.124 3.05 3.05 0 0 0 2.196-.927l5.583-5.553zm-10.091-2.564-6.042 6.009c-.027.028-.047.049-.104.024-.069-.028-.069-.073-.069-.113v-4.856a1.5 1.5 0 0 0-1.5-1.5h-1.619a3.36 3.36 0 0 1-3.356-3.356V22.285a3.36 3.36 0 0 1 3.356-3.356h19.426c.894 0 1.735.35 2.371.985.636.636.985 1.478.985 2.371v12.951a3.36 3.36 0 0 1-3.356 3.356H32.68c-.397 0-.777.157-1.058.436z"
                              fill="#9ceebd"
                              opacity="1"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M24.713 26.787c-1.22 0-2.213.994-2.213 2.213s.994 2.213 2.213 2.213c1.221 0 2.215-.994 2.215-2.213s-.993-2.213-2.215-2.213zM31.999 26.787c-1.22 0-2.213.994-2.213 2.213s.994 2.213 2.213 2.213c1.222 0 2.215-.994 2.215-2.213s-.993-2.213-2.215-2.213zM39.285 26.787c-1.22 0-2.213.994-2.213 2.213s.994 2.213 2.213 2.213c1.221 0 2.215-.994 2.215-2.213s-.994-2.213-2.215-2.213z"
                              fill="#9ceebd"
                              opacity="0.35"
                              data-original="#9ceebd"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Risk Assessments</h2>
                        <p>
                          We conduct thorough audits to identify gaps in your
                          data protection protocols and evaluate your current
                          compliance standing.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 682.667 682.667"
                        >
                          <g>
                            <defs>
                              <clipPath id="a" clipPathUnits="userSpaceOnUse">
                                <path
                                  d="M0 512h512V0H0Z"
                                  fill="#9ccdee"
                                  opacity="0.35"
                                  data-original="#9ccdee"
                                ></path>
                              </clipPath>
                            </defs>
                            <path
                              d="M0 0h141.485l27.006 90.369H-12.757"
                              transform="matrix(1.33333 0 0 -1.33333 257.672 383.628)"
                              fill="none"
                              stroke="#9ccdee"
                              stroke-width="20"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#9ccdee"
                              opacity="0.35"
                            ></path>
                            <path
                              d="M0 0h-131.957l-20.668 160.11h-37.587"
                              transform="matrix(1.33333 0 0 -1.33333 437.86 435.441)"
                              fill="none"
                              stroke="#9ccdee"
                              stroke-width="20"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-dasharray="none"
                              data-original="#9ccdee"
                              opacity="0.35"
                            ></path>
                            <g
                              clip-path="url(#a)"
                              transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                            >
                              <path
                                d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                transform="translate(242.644 162.873)"
                                fill="none"
                                stroke="#9ccdee"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ccdee"
                                opacity="0.35"
                              ></path>
                              <path
                                d="M0 0c0-12.442-10.071-22.529-22.495-22.529C-34.919-22.529-44.99-12.442-44.99 0c0 12.443 10.071 22.53 22.495 22.53C-10.071 22.53 0 12.443 0 0Z"
                                transform="translate(332.929 162.889)"
                                fill="none"
                                stroke="#9ccdee"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ccdee"
                                opacity="0.35"
                              ></path>
                              <path
                                d="M0 0h-240.825c-21.093 0-38.193 17.1-38.193 38.193v41.639H38.193V38.193C38.193 17.1 21.093 0 0 0Z"
                                transform="translate(376.413 10)"
                                fill="none"
                                stroke="#9ccdee"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ccdee"
                              ></path>
                              <path
                                d="M0 0h-317.211v374.065c0 21.044 17.14 38.103 38.284 38.103h240.643C-17.141 412.168 0 395.109 0 374.065Z"
                                transform="translate(414.606 89.832)"
                                fill="none"
                                stroke="#9ccdee"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ccdee"
                              ></path>
                              <path
                                d="M0 0h13.333"
                                transform="translate(249.333 49.916)"
                                fill="none"
                                stroke="#9ccdee"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ccdee"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0h94.979"
                                transform="translate(208.51 462.447)"
                                fill="none"
                                stroke="#9ccdee"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ccdee"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Policy Development & Implementation</h2>
                        <p>
                          From incident response to data access policies, we
                          help you implement security protocols aligned with
                          HIPAA standards.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 512 512"
                        >
                          <g>
                            <path
                              d="M192 464h-64a8 8 0 0 0 0 16h64a8 8 0 0 0 0-16z"
                              fill="#cb9cee"
                              opacity="1"
                              data-original="#cb9cee"
                            ></path>
                            <path
                              d="M468 160H304V36a28.031 28.031 0 0 0-28-28H44a28.031 28.031 0 0 0-28 28v440a28.031 28.031 0 0 0 28 28h232a28.031 28.031 0 0 0 28-28V360h164a28.031 28.031 0 0 0 28-28V188a28.031 28.031 0 0 0-28-28zM197.75 24l-4 16h-67.5l-4-16zM288 476a12.01 12.01 0 0 1-12 12H44a12.01 12.01 0 0 1-12-12V36a12.01 12.01 0 0 1 12-12h61.75l6.49 25.94A8 8 0 0 0 120 56h80a8 8 0 0 0 7.76-6.06L214.25 24H276a12.01 12.01 0 0 1 12 12zm16-196h24v32h-24zm176 52a12.01 12.01 0 0 1-12 12H304v-16h32a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-32v-24h176zm0-108H304v-16h176zm0-32H304v-16h164a12.01 12.01 0 0 1 12 12z"
                              fill="#cb9cee"
                              opacity="1"
                              data-original="#cb9cee"
                            ></path>
                            <path
                              d="M456 264h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 288h-72a8 8 0 0 0 0 16h72a8 8 0 0 0 0-16zM456 312h-32a8 8 0 0 0 0 16h32a8 8 0 0 0 0-16zM160 160a96 96 0 1 0 96 96 96.108 96.108 0 0 0-96-96zm0 176a80 80 0 1 1 80-80 80.091 80.091 0 0 1-80 80z"
                              fill="#cf8fff"
                              opacity="0.15"
                              data-original="#cf8fff"
                            ></path>
                            <path
                              d="m202.343 226.343-51.094 51.094L124.8 257.6a8 8 0 1 0-9.6 12.8l32 24a8 8 0 0 0 10.457-.743l56-56a8 8 0 0 0-11.314-11.314z"
                              fill="#cf8fff"
                              opacity="0.15"
                              data-original="#cf8fff"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Staff Training & Awareness</h2>
                        <p>
                          We deliver training programs to ensure your team
                          understands their role in maintaining HIPAA
                          compliance.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 68 68"
                        >
                          <g>
                            <path
                              d="M46.124 55.036c-3.038 0-5.634-.89-7.482-2.738-5.222-5.222-2.816-16.404 5.72-26.59a5.002 5.002 0 0 1 3.605-1.769c1.414-.05 2.801.476 3.8 1.474l1.009 1.01a1 1 0 1 1-1.414 1.415l-1.01-1.01a3.05 3.05 0 0 0-2.298-.89 2.952 2.952 0 0 0-2.16 1.055c-7.727 9.22-10.237 19.491-5.838 23.89 4.393 4.393 14.658 1.882 23.881-5.84A2.962 2.962 0 0 0 65 42.88a3.075 3.075 0 0 0-.897-2.303l-1.01-1.01a1 1 0 1 1 1.414-1.414l1.01 1.01a5.08 5.08 0 0 1 1.48 3.804 5.006 5.006 0 0 1-1.774 3.61c-6.577 5.505-13.567 8.46-19.098 8.46z"
                              fill="#dcdc30"
                              opacity="1"
                              data-original="#dcdc30"
                            ></path>
                            <path
                              d="M62.034 40.596h-.001a3.458 3.458 0 0 1-2.475-1.033 3.447 3.447 0 0 1-1.024-2.455 3.477 3.477 0 0 1 1.028-2.485 3.453 3.453 0 0 1 2.47-1.027h.002a3.46 3.46 0 0 1 2.475 1.03 3.478 3.478 0 0 1 1.025 2.482 3.452 3.452 0 0 1-1.028 2.46 3.459 3.459 0 0 1-2.472 1.028zm0-5c-.4 0-.775.155-1.054.437-.29.29-.447.67-.446 1.07 0 .396.157.768.438 1.046.287.29.661.447 1.062.447.4 0 .774-.157 1.054-.439l.008-.008c.282-.278.437-.65.438-1.045a1.493 1.493 0 0 0-.442-1.067 1.476 1.476 0 0 0-1.058-.441zM53.836 32.393a3.485 3.485 0 0 1-3.503-3.492c0-.935.366-1.815 1.029-2.477a3.529 3.529 0 0 1 4.95-.004l.008.008a3.527 3.527 0 0 1 0 4.946 3.52 3.52 0 0 1-2.484 1.019zm.002-4.988c-.385 0-.771.146-1.066.437a1.496 1.496 0 0 0 .004 2.122 1.523 1.523 0 0 0 2.13-.004 1.52 1.52 0 0 0-.004-2.122 1.508 1.508 0 0 0-1.064-.433zM37.409 57.33a3.778 3.778 0 0 1-2.682-1.124 3.836 3.836 0 0 1 0-5.42l2.291-2.292a1 1 0 1 1 1.414 1.414L36.14 52.2a1.824 1.824 0 0 0 0 2.59 1.79 1.79 0 0 0 1.27.54h.016a1.855 1.855 0 0 0 1.307-.54l2.291-2.291a1 1 0 1 1 1.414 1.414l-2.292 2.292a3.844 3.844 0 0 1-2.702 1.124h-.035z"
                              fill="#dcdc30"
                              opacity="1"
                              data-original="#dcdc30"
                            ></path>
                            <path
                              d="M22.11 62.715c-2.875 0-5.47-.906-7.358-2.794-3.913-3.912-3.745-10.873.42-17.32a.999.999 0 1 1 1.68 1.084c-3.64 5.636-3.916 11.592-.686 14.822 4.093 4.094 12.42 2.427 18.562-3.714a1 1 0 1 1 1.414 1.414c-4.24 4.24-9.485 6.508-14.032 6.508z"
                              fill="#dcdc30"
                              opacity="1"
                              data-original="#dcdc30"
                            ></path>
                            <path
                              d="M20.723 46.108a7.657 7.657 0 0 1-5.43-2.246c-2.995-2.994-2.995-7.866 0-10.86 2.995-2.993 7.867-2.992 10.86 0a7.628 7.628 0 0 1 2.246 5.43 7.626 7.626 0 0 1-2.246 5.43 7.656 7.656 0 0 1-5.43 2.246zm0-13.352a5.664 5.664 0 0 0-4.016 1.66 5.685 5.685 0 0 0 0 8.032 5.685 5.685 0 0 0 8.032 0 5.64 5.64 0 0 0 1.66-4.015c0-1.519-.59-2.945-1.66-4.016a5.663 5.663 0 0 0-4.017-1.661z"
                              fill="#dcdc30"
                              opacity="1"
                              data-original="#dcdc30"
                            ></path>
                            <path
                              d="M20.722 41.658a3.205 3.205 0 0 1-2.281-.944 3.23 3.23 0 0 1 0-4.563c1.22-1.22 3.347-1.217 4.562 0a3.23 3.23 0 0 1 0 4.563 3.202 3.202 0 0 1-2.28.944zm0-4.451a1.227 1.227 0 0 0-.867 2.093c.463.463 1.272.462 1.734 0a1.227 1.227 0 0 0-.867-2.093z"
                              fill="#dcdc30"
                              opacity="0.45"
                              data-original="#dcdc30"
                            ></path>
                            <path
                              d="M41.279 67H4.059A3.063 3.063 0 0 1 1 63.94V11.33a3.063 3.063 0 0 1 3.06-3.06h8.4a1 1 0 1 1 0 2h-8.4c-.585 0-1.06.476-1.06 1.06v52.61c0 .575.485 1.06 1.06 1.06h37.22c.574 0 1.06-.485 1.06-1.06V53.73a1 1 0 1 1 2 0v10.21a3.062 3.062 0 0 1-3.06 3.06zM43.338 29.63a1 1 0 0 1-1-1v-17.3c0-.584-.475-1.06-1.06-1.06h-8.4a1 1 0 1 1 0-2h8.4a3.062 3.062 0 0 1 3.06 3.06v17.3a1 1 0 0 1-1 1z"
                              fill="#dcdc30"
                              opacity="0.45"
                              data-original="#dcdc30"
                            ></path>
                            <path
                              d="M31.029 13.483H14.306a2.85 2.85 0 0 1-2.846-2.846V7.905a2.85 2.85 0 0 1 2.846-2.845h3.406C18.177 2.747 20.22 1 22.662 1a5.067 5.067 0 0 1 4.96 4.06h3.407a2.85 2.85 0 0 1 2.847 2.845v2.732a2.85 2.85 0 0 1-2.847 2.846zM14.306 7.06a.847.847 0 0 0-.846.845v2.732c0 .467.38.846.846.846H31.03c.467 0 .847-.38.847-.846V7.905a.847.847 0 0 0-.847-.845H26.72a1 1 0 0 1-1-1A3.062 3.062 0 0 0 22.663 3a3.058 3.058 0 0 0-3.05 3.06 1 1 0 0 1-1 1zM22.669 18.88H7.399a1 1 0 1 1 0-2h15.27a1 1 0 1 1 0 2zM37.939 23.352H7.399a1 1 0 1 1 0-2h30.54a1 1 0 1 1 0 2zM37.939 27.822H7.399a1 1 0 1 1 0-2h30.54a1 1 0 1 1 0 2z"
                              fill="#dcdc30"
                              opacity="0.45"
                              data-original="#dcdc30"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Ongoing Compliance Monitoring</h2>
                        <p>
                          Our tools help you track compliance over time,
                          generate reports, and stay ahead of any changes in
                          regulatory requirements.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 682.667 682.667"
                        >
                          <g>
                            <defs>
                              <clipPath id="a" clipPathUnits="userSpaceOnUse">
                                <path
                                  d="M0 512h512V0H0Z"
                                  fill="#ff9393"
                                  opacity="1"
                                  data-original="#ff9393"
                                ></path>
                              </clipPath>
                            </defs>
                            <g
                              clip-path="url(#a)"
                              transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                            >
                              <path
                                d="M0 0h177.615c12.042 0 21.803-9.762 21.803-21.803v-67.669"
                                transform="translate(88.678 504.5)"
                                fill="none"
                                stroke="#ff9393"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#ff9393"
                              ></path>
                              <path
                                d="M0 0c-3.661-6.899-10.917-11.598-19.272-11.598h-236.99c-12.042 0-21.803 9.762-21.803 21.803v453.394c0 12.041 9.761 21.803 21.803 21.803h18.85"
                                transform="translate(285.565 19.098)"
                                fill="none"
                                stroke="#ff9393"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#ff9393"
                              ></path>
                              <path
                                d="M0 0h-198.833v361.486H81.763v-38.25"
                                transform="translate(206.333 91.792)"
                                fill="none"
                                stroke="#ff9393"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#ff9393"
                              ></path>
                              <path
                                d="M0 0h-44.385c-6.928 0-12.544 5.616-12.544 12.544 0 6.928 5.616 12.543 12.544 12.543H0c6.928 0 12.543-5.615 12.543-12.543C12.543 5.616 6.928 0 0 0Z"
                                transform="translate(169.99 37.056)"
                                fill="none"
                                stroke="#ff9393"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#ff9393"
                              ></path>
                              <path
                                d="M0 0c-18.9-7.994-39.68-12.415-61.492-12.415-87.248 0-157.976 70.729-157.976 157.977 0 57.964 31.217 108.637 77.756 136.123"
                                transform="translate(408.015 19.915)"
                                fill="none"
                                stroke="#ff9393"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#ff9393"
                                opacity="0.25"
                              ></path>
                              <path
                                d="M0 0a159.157 159.157 0 0 0 24.713 1.921c87.248 0 157.977-70.728 157.977-157.976 0-49.6-22.858-93.861-58.615-122.823"
                                transform="translate(321.81 321.532)"
                                fill="none"
                                stroke="#ff9393"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#ff9393"
                                opacity="0.25"
                              ></path>
                              <path
                                d="m0 0 10.274-9.897 12.014-39.377c3.81-12.491 19.656-16.265 28.687-6.831l31.14 32.523 43.159 3.692a17.087 17.087 0 0 1 14.377 10.598l17.886 44.05c-25.303 52.426-78.716 88.73-140.676 89.376l5.957-52.609-26.447-45.869A21.033 21.033 0 0 1 0 0Z"
                                transform="translate(331.34 199.299)"
                                fill="none"
                                stroke="#ff9393"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#ff9393"
                                opacity="0.25"
                              ></path>
                              <path
                                d="m0 0-36.247-5.074a19.997 19.997 0 0 0-10.827 1.5l-9.863 4.34A20.001 20.001 0 0 0-68.76 21.281l4.212 37.903a20.002 20.002 0 0 1-5.189 15.782l-48.351 52.326C-144.595 22.032-61.389-77.18 45.975-69.916L21.16-11.937A20 20 0 0 1 0 0Z"
                                transform="translate(311.647 77.81)"
                                fill="none"
                                stroke="#ff9393"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#ff9393"
                                opacity="0.25"
                              ></path>
                              <path
                                d="m0 0-52.041 46.493 28.941 8.472 79.961-28.799"
                                transform="translate(267.843 375.677)"
                                fill="none"
                                stroke="#ff9393"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#ff9393"
                                opacity="0.45"
                              ></path>
                              <path
                                d="m0 0 90.818 26.625c16.223 4.75 19.846 26.147 6.051 35.917-17.082 12.097-41.93 21.097-72.515 7.938-60.426-25.996-190.922-88.051-190.922-88.051l-19.049 26.589-18.312-5.361 10.906-37.256c3.404-11.63 15.592-18.298 27.222-14.894l95.51 27.958"
                                transform="translate(344.46 350.98)"
                                fill="none"
                                stroke="#ff9393"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#ff9393"
                                opacity="0.45"
                              ></path>
                              <path
                                d="m0 0-22.423-80.36 28.942 8.472 73.237 95.234"
                                transform="translate(279.727 347.168)"
                                fill="none"
                                stroke="#ff9393"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#ff9393"
                                opacity="0.45"
                              ></path>
                              <path
                                d="m0 0 44.575 12.922a20.355 20.355 0 0 1-5.094 5.163C22.399 30.182-2.448 39.182-33.034 26.023l-.686-.295 4.377-10.428C-25.183 3.212-12.293-3.508 0 0Z"
                                transform="translate(401.848 395.437)"
                                fill="none"
                                stroke="#ff9393"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                opacity="0.45"
                                stroke-dasharray="none"
                                data-original="#ff9393"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Business Associate Management</h2>
                        <p>
                          We assist in vetting, documenting, and managing
                          third-party vendors to ensure their compliance with
                          HIPAA standards.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugItroWrap staffAugValueWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imgWrap">
                  <img src={DedicatedTeamsImg3} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadRt">
                  <h2>What You Get With Hummingtec</h2>
                  <p>
                    After every HIPAA IT audit or service, you will receive:
                  </p>
                  <ul>
                    <li>
                      <strong>1. </strong> A full compliance status report
                    </li>
                    <li>
                      <strong>2. </strong> Actionable next steps to mitigate
                      risks
                    </li>
                    <li>
                      <strong>3. </strong> A roadmap for maintaining long-term
                      security
                    </li>
                    <li>
                      <strong>4. </strong> Expert consultation for future
                      compliance challenges
                    </li>
                  </ul>
                  <p>
                    We support both <strong>covered entities</strong> and{" "}
                    <strong>business associates</strong> across the healthcare
                    spectrum, ensuring robust protection of patient data in a
                    digital-first world.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="whyHumingtecSec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>Ready to Secure Your Healthcare IT?</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="dataWrap">
                  <p>
                    Whether you're a healthcare provider, software vendor, or
                    service company dealing with PHI—
                    <strong>
                      Hummingtec is your trusted partner for HIPAA compliance
                      and IT security
                    </strong>
                    .
                  </p>
                  <p>
                    {" "}
                    <Link className="btn" to="/Contact">
                      Contact Us
                    </Link>{" "}
                    today to schedule a consultation and start building your
                    HIPAA-compliant future.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};
export default HIPAACompliance;
